import React from "react";
import { Col, Row } from "react-bootstrap";
import SearchInput from "../../../widget/common/form/SearchInput";
import ChatList from "./widget/ChatList";
import { ChatsContentType } from "../../../libraries/types_interface/chats/ChatsTypes";
import Div from "../../../widget/common/ui/Div";
import { Position } from "../../../widget/common/ui/Stack";
import { MainContainer } from "../../../widget/common/ui/MainContainer";
import ConversationContent from "../widget/chat_conversation/ConversationContent";
import NoData from "../../../widget/common/ui/NoData";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { ChatsContextImport } from "../../../provider/chats/chats/chats/ChatsContextProvider";
import ChatSidebar from "./widget/ChatSidebar";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

const minBrowserWidth: number = UtilityHelper.defaultWidthMin;

const ChatsContentWeb: React.FC<ChatsContentType> = ({
  chats,
  type,
  browserWidth,
  chatSelected,
  loadingMesages = false,
}) => {
  const { searchValue, searchHandleChange, searchClear } = ChatsContextImport();

  const chatProfiles: JSX.Element = (
    <>
      <Div className="px-4">
        <SearchInput
          name="search-profile-onversation"
          placeHolder="search"
          handleOnChange={searchHandleChange}
          onClickSuffix={searchClear}
          value={searchValue}
        />
      </Div>
      <Div className="h-100 overflow-auto position-relative">
        <Position top={0} left={0} className="w-100">
          <ChatList chats={chats} type={type} />
        </Position>
      </Div>
    </>
  );

  const chatConversation: JSX.Element = loadingMesages ? (
    <Center className="h-100">{Loader.normal()}</Center>
  ) : chatSelected == null ? (
    <Center className="h-100">
      <NoData />
    </Center>
  ) : (
    <ConversationContent />
  );

  /* const chatConversation: JSX.Element =
    chatSelected == null ? (
      <Center className="h-100">
        <NoData />
      </Center>
    ) : (
      <ConversationContent />
    ); */

  return (
    <>
      {(browserWidth ?? minBrowserWidth) < minBrowserWidth ? (
        <MainContainer className="h-100">
          <Row className="h-100 mx-0 chats-web">
            <Col md={4} className="bgcolor-grey9 py-3 px-0 chat-list-wrap">
              {chatProfiles}
            </Col>
            <Col md={8} className="h-100 px-0">
              {chatConversation}
            </Col>
          </Row>
        </MainContainer>
      ) : (
        <Row className="h-100 mx-0 chats-web">
          <Col md={2} />
          <Col md={3} className="bgcolor-grey9 py-3 px-0 chat-list-wrap">
            {chatProfiles}
          </Col>
          <Col md={5} className="h-100  px-0">
            {chatConversation}
          </Col>
          <Col md={2}></Col>
        </Row>
      )}
      <ChatSidebar />
    </>
  );
};

export default ChatsContentWeb;
